"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));

var React = _interopRequireWildcard(require("react"));

var _classnames = _interopRequireDefault(require("classnames"));

var _Arrow = _interopRequireDefault(require("./Arrow"));

var _Title = _interopRequireDefault(require("./Title"));

var _ThemeProvider = require("../../../theme/ThemeProvider");

var _Body = _interopRequireDefault(require("./Body.style"));

var useStyles = (0, _ThemeProvider.createUseStyles)(_Body["default"]);
/**
 * PopoverBody
 */

var PopoverBody = function PopoverBody(_ref) {
  var children = _ref.children,
      classes = _ref.classes,
      className = _ref.className,
      placement = _ref.placement,
      arrowOffset = _ref.arrowOffset,
      title = _ref.title,
      _ref$size = _ref.size,
      size = _ref$size === void 0 ? 'normal' : _ref$size,
      _ref$noArrow = _ref.noArrow,
      noArrow = _ref$noArrow === void 0 ? false : _ref$noArrow,
      rest = (0, _objectWithoutProperties2["default"])(_ref, ["children", "classes", "className", "placement", "arrowOffset", "title", "size", "noArrow"]);
  var theme = (0, _ThemeProvider.useTheme)();
  var generatedClasses = useStyles({
    theme: theme,
    props: {
      size: size
    }
  });
  if (!classes) classes = generatedClasses;
  return /*#__PURE__*/React.createElement("div", (0, _extends2["default"])({}, rest, {
    className: (0, _classnames["default"])(classes.Popover, className)
  }), !noArrow && /*#__PURE__*/React.createElement(_Arrow["default"], {
    placement: placement,
    arrowOffset: arrowOffset
  }), /*#__PURE__*/React.createElement("div", {
    className: classes.Inner
  }, title && /*#__PURE__*/React.createElement(_Title["default"], {
    className: classes.Title
  }, title), /*#__PURE__*/React.createElement("div", {
    className: classes.Content
  }, children)));
};

exports["default"] = PopoverBody;
PopoverBody.defaultProps = {
  placement: 'top',
  arrowOffset: 0
};
//# sourceMappingURL=Body.js.map